const careerVideoContainer = document.querySelectorAll('.career-video-container');

if (typeof(careerVideoContainer) != 'undefined' && careerVideoContainer != null) {
    for (let i = 0; i < careerVideoContainer.length; i++) {
        const vimeoElm = careerVideoContainer[i].querySelector('.career-vimeo-player');
        const vimeoElmURL = careerVideoContainer[i].querySelector('.career-vimeo-player').getAttribute('data-vimeo-url');
        const videoPoster = careerVideoContainer[i].querySelector('.career-poster');
        const videoAction = careerVideoContainer[i].querySelector('.career-video-action');


        let requestURL = 'https://vimeo.com/api/oembed.json?url=' + vimeoElmURL;

        const loadVimeoResponse = async(requestURL) => {
            try {
                const res = await fetch(requestURL);
                let responseJSON = await res.json();
                let vimeoHTML = responseJSON.html;
                vimeoElm.insertAdjacentHTML('beforeend' , vimeoHTML);
                videoPoster.remove();
                videoAction.remove();
        
            } catch (err) {
                console.error(err);
            }
        };

        videoAction.addEventListener("click", function() {
            loadVimeoResponse(requestURL);
        });
    }
}